const TWINE_ROUTES = {
  HOME: {
    ROOT: '/admin/home'
  }
}

export { TWINE_ROUTES }
